// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab__selected[data-v-6cd018b0]{background-color:#e7edf0!important}ul>li[data-v-6cd018b0]{border:1px solid #9ab1bf;border-left:none}ul>li[data-v-6cd018b0]:first-child{border-left:1px solid #9ab1bf;border-top-left-radius:1rem}ul>li[data-v-6cd018b0]:last-child{border-top-right-radius:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
